<template>
  <div class="FileList mt-2">
    <div 
      v-for="file in files"
      :key="`file_${file.uuid}`"
      class="d-inline-flex w-100">
        <FileUuidDownloadLink 
          :uuid="file.uuid"
          :icon="true"
          :disconnect="true"
          :disabled="disabled"
          :filenameprefix="filenameprefix"
          v-on="$listeners" />
    </div>
  </div>
</template>

<script>
import FileUuidDownloadLink from '@/components/request/FileUuidDownloadLink.vue'

export default {
  name: 'FileList',
  components: {
    FileUuidDownloadLink
  },
  props: {
    files: {
      type: Array,
      required: true
    },
    wide: {
      type: Boolean,
      default: true
    },
    linklabel: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filenameprefix: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">

.FileList {
  .text-button {
    display: flex;
    align-items: center;
    font-family: inherit;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: $primary-darkblue;
    fill: $primary-darkblue;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    cursor: pointer;

    .text-button__label {
      @include breakpoint('s') {
        display: none;
      }
    }

    &:hover {
      color: $primary-red;
      fill: $primary-red;
    }

    &:focus,
    &:active {
      outline: 2px solid $primary-black;
    }

    .b-icon {
      margin-right: 0.3em;
    }
  }
}
</style>

